'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Breads = undefined;

var _Breads2 = require('./Breads');

var _Breads3 = _interopRequireDefault(_Breads2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Breads = _Breads3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/CartProduct/Breads/index.js
// module id = 1626
// module chunks = 0